import { convertStringToCamelCaseId } from "../../utils/convertStringToCamelCaseId";
export const convertTagNameToId = (title) => {
    const normalizedTitle = title.replace(/\+/g, "Plus");
    return convertStringToCamelCaseId(normalizedTitle);
};
export const convertNameToId = (name) => {
    return convertStringToCamelCaseId(name);
};
